<template>
  <v-container>
    <v-app>
      <v-card elevation="2">
        <v-card-text>
          <v-alert v-if="isFailure && errorMessage" type="error">{{
            errorMessage
          }}</v-alert>

          <v-alert v-if="isFailureGet && errorMessageGet" type="error">{{
            errorMessage
          }}</v-alert>

          <v-row class="mb-4">
            <v-col>
              <v-btn @click="goBack">{{ $ml.get("button.back") }}</v-btn>
            </v-col>

            <v-spacer />

            <v-col v-if="form" cols="auto">
              <v-row>
                <v-col cols="auto">
                  <v-btn
                    v-if="
                      ($auth.user().type_user == 'admin' ||
                        $auth.user().roles.includes('reqconfirm')) &&
                      form.status === 0
                    "
                    color="success"
                    @click="confirmRequest"
                  >
                    {{ $ml.get("requests.confirmRequest") }}</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    v-if="
                      ($auth.user().type_user == 'admin' ||
                        $auth.user().roles.includes('reqconfirm')) &&
                      (form.status === 0 || form.status === 1)
                    "
                    color="error"
                    @click="cancelRequest"
                    >{{ $ml.get("requests.cancelRequest") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <Form
            v-if="form"
            ref="editForm"
            :name="form.name"
            :description="form.description"
            :email="form.contacts.email"
            :phone="form.contacts.phone"
            :onepass="form.contacts.onepass"
            :dueFrom="form.due_from"
            :dueTo="form.due_to"
            :subdivisions="form.subdivisions"
            :status="form.status"
            :requestType="form.request_type"
            :department="form.contacts.department"
            :purpose="form.contacts.purpose"
            @change="onChange"
          />

          <v-row v-if="form" justify="end">
            <v-col cols="auto">
              <v-btn
                v-if="form.status === 1"
                class="mr-3"
                color="primary"
                @click="resend"
              >
                {{ $ml.get("requests.resend") }}</v-btn
              >
              <v-btn
                v-if="form.identifier && isShowCopyPincode"
                v-clipboard:copy="form.identifier"
                v-clipboard:success="onCopyPincode"
                :color="isCopiedPincode ? 'success' : ''"
              >
                <v-icon v-if="isCopiedPincode" left> mdi-check </v-icon>
                {{ $ml.get("requests.copyPin") }}</v-btn
              >
              <v-btn
                v-if="form.link && isShowCopyUrl"
                class="ml-3"
                v-clipboard:copy="form.link"
                v-clipboard:success="onCopyUrl"
                :color="isCopiedUrl ? 'success' : ''"
              >
                <v-icon v-if="isCopiedUrl" left> mdi-check </v-icon>
                {{ $ml.get("requests.copyUrl") }}</v-btn
              >
              <v-btn
                v-if="form.status === 0"
                color="primary"
                class="ml-3"
                @click="save"
                >{{ $ml.get("button.save") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-app>
  </v-container>
</template>

<script>
import Form from "./form";

export default {
  components: { Form },

  data() {
    return {
      isPendingGet: false,
      isSuccessGet: false,
      isFailureGet: false,
      errorMessageGet: "",

      isPending: false,
      isSuccess: false,
      isFailure: false,
      errorMessage: "",
      id: 0,
      form: null,

      isCopiedPincode: false,
      isCopiedUrl: false,
    };
  },

  watch: {
    $route: "getRequest",
  },

  methods: {
    goBack() {
      this.$router.push({ path: `/requests` });
    },

    onChange(form) {
      this.form = { ...this.form, ...form };
    },

    save(isRedirect = true) {
      const validate = this.$refs.editForm.$refs.form.validate();
      const validateSubdivisions = this.$refs.editForm.validateSubdivisions();
      const validateDepartments = this.$refs.editForm.validateDepartments();

      if (validate && validateSubdivisions && validateDepartments) {
        const { form } = this;

        this.isPending = true;
        this.isSuccess = false;
        this.isFailure = false;

        return axios
          .put(`request/${this.id}`, form)
          .then(() => {
            this.isPending = false;
            this.isSuccess = true;
            this.isFailure = false;

            if (isRedirect) {
              this.$router.push({ name: "requests" });
            }
          })
          .catch((error) => {
            this.isPending = false;
            this.isSuccess = false;
            this.isFailure = true;
            this.errorMessage = error.response.data.status.message;
          });
      }
    },

    getRequest() {
      this.id = this.$route.params.id;

      this.isPendingGet = true;
      this.isSuccessGet = false;
      this.isFailureGet = false;

      axios(`request/${this.id}`)
        .then((response) => {
          this.isPendingGet = false;
          this.isSuccessGet = true;
          this.isFailureGet = false;

          this.form = { ...response.data.data };
        })
        .catch((error) => {
          this.isPendingGet = false;
          this.isSuccessGet = false;
          this.isFailureGet = true;
          this.errorMessageGet = error.response.data.status.message;
        });
    },

    onCopyPincode() {
      this.isCopiedPincode = true;
    },

    onCopyUrl() {
      this.isCopiedUrl = true;
    },

    async confirmRequest() {
      await this.save(false);

      axios
        .put(`request/${this.id}/status`, {
          status: 1,
        })
        .then(() => {
          this.form.status = 1;

          this.getRequest();
        });
    },

    cancelRequest() {
      axios
        .put(`request/${this.id}/status`, {
          status: 3,
        })
        .then(() => {
          this.form.status = 3;

          this.getRequest();
        });
    },

    resend() {
      axios(`request/resend/${this.id}`)
        .then(() => {
          this.$notify({
            group: "info",
            type: "success",
            text: this.$ml.get("requests.resendSuccessMessage"),
          });
        })
        .catch((error) => {
          this.$notify({
            group: "info",
            type: "error",
            text: error.response.data.status.message,
          });
        });
    },
  },

  computed: {
    isShowCopyPincode() {
      let isShow = false;

      const requestTypeSplit = String(this.form.request_type)
        .split("")
        .map((num) => {
          return Number(num);
        });

      if (requestTypeSplit.includes(0)) {
        if (this.form.status === 1 || this.form.status === 2) {
          isShow = true;
        } else {
          isShow = false;
        }
      }

      return isShow;
    },

    isShowCopyUrl() {
      let isShow = false;

      const requestTypeSplit = String(this.form.request_type)
        .split("")
        .map((num) => {
          return Number(num);
        });

      if (requestTypeSplit.includes(1)) {
        if (this.form.status === 1 || this.form.status === 2) {
          isShow = true;
        } else {
          isShow = false;
        }
      }

      return isShow;
    },
  },

  created() {
    this.getRequest();
  },
};
</script>
